export default __webpack_public_path__ + "static/media/subscription_feature_004.4cd95f27.svg";